import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  q: '¿Es material digital?',
  a: 'Sí, todo el contenido es en PDF de alta calidad. Podés abrirlo desde cualquier dispositivo — computadora, tablet o celular. Funciona sin internet una vez descargado.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Al completar el pago recibís un mail con el link de descarga inmediato. El acceso es instantáneo — no tenés que esperar.'
}, {
  q: '¿Sirve para los dos niveles o solo para uno?',
  a: 'Sirve para los dos. Recibís el MegaPack Primaria completo Y el MegaPack Secundaria completo. Si solo das un nivel, igual te conviene — tenés el otro disponible para cuando lo necesites.'
}, {
  q: '¿Puedo imprimirlo para mis alumnos?',
  a: 'Sí. Los tomos incluyen fichas imprimibles pensadas para imprimir y repartir en clase. El formato está optimizado para A4.'
}, {
  q: '¿Necesito experiencia previa en arte para usarlo?',
  a: 'No. El material está pensado para cualquier docente de Arte o Plástica, desde los primeros años de ejercicio hasta los más experimentados.'
}, {
  q: '¿Puedo usarlo durante todo el año?',
  a: 'Sí. El sistema cubre el año escolar completo — los 6 tomos de cada nivel están diseñados para avanzar en secuencia o usarse de forma independiente según lo que necesitás en cada momento.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí. Tenés 7 días de garantía total. Si no estás conforme, te devolvemos el dinero sin ninguna pregunta.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 lg:py-32 bg-paper-main" data-id="element-44">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-46">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-terra-50 text-terra-600 font-medium text-xs uppercase tracking-widest mb-6 border border-terra-100" data-id="element-47">
            Preguntas frecuentes
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-800 mb-6 leading-tight tracking-tight" data-id="element-48">
            Resolvemos tus <span className="text-brand-500" data-id="element-49">dudas</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-50">
          {faqs.map((faq, index) => {
          const open = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.04,
            duration: 0.8,
            ease: 'easeOut'
          }} className={`bg-paper-card rounded-[20px] border transition-all duration-300 overflow-hidden ${open ? 'border-brand-200 shadow-md' : 'border-paper-border shadow-sm'}`} data-id="element-51">
                <button onClick={() => setOpenIndex(open ? null : index)} className="w-full px-8 py-6 text-left flex justify-between items-center focus:outline-none gap-6" aria-expanded={open} data-id="element-52">
                  <span className="font-medium text-ink-800 text-base lg:text-lg" data-id="element-53">
                    {faq.q}
                  </span>
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 shrink-0 ${open ? 'bg-brand-500 text-white rotate-45' : 'bg-paper-main text-brand-500 border border-paper-border'}`} data-id="element-54">
                    <Plus className="w-5 h-5" strokeWidth={1.5} data-id="element-55" />
                  </div>
                </button>
                <AnimatePresence data-id="element-56">
                  {open && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-57">
                      <div className="px-8 pb-8 text-ink-600 leading-relaxed font-normal" data-id="element-58">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}